import {http_client} from "@/plugins/http_client";

const planilla_url = `${process.env.VUE_APP_URL_API_PLANILLA}`

const getHistorialEvaluacion = async (id_oferta_persona, params = {}) => {
  return await http_client(`${planilla_url}/api/v1/contratacion-evaluacion/historial/${id_oferta_persona}`, params, 'get')
}

const getEvaluacion = async (id_solicitud_evaluacion, id_persona_evaluacion, params = {}) => {
  return await http_client(`${planilla_url}/api/v1/contratacion-evaluacion/evaluacion/${id_solicitud_evaluacion}/${id_persona_evaluacion}`, params, 'get')
}

export default {
  getHistorialEvaluacion,
  getEvaluacion
}
